export default {
  'password.customerCode': 'Customer ID',
  /** @prop {string} password.leadBankCode is left blank on purpose */
  'password.leadBankCode': '',
  'password.match': 'The password fields must match',
  'password.minimum.characters':
    'Length must be between <%=minLength %> and <%=maxLength %> characters',
  'password.minimum.digit': 'A minimum of 1 digit is required',
  'password.minimum.lowercase': 'A minimum of 1 lowercase letter is required',
  'password.minimum.personal': 'Password cannot contain <%=exclusions %>.',
  'password.minimum.special': 'A minimum of 1 special character is required',
  'password.minimum.uppercase': 'A minimum of 1 uppercase letter is required',
  'password.missingToken': 'Action incomplete. Please restart Forgot Password process',
  'password.passwordChanged': 'Password Changed',
  'password.success':
    'A temporary password has been issued to your email address on file: <%=email %>. Please use this temporary password immediately.',
  'password.userCode': 'User ID'
};
